import { useEffect } from 'react'

import PaymentOrdersTemplate from 'Components/UI/Templates/Sales/PaymentOrders'

const PaymentOrders = () => {
  useEffect(() => {
    document.title = 'Ordenes de pago'
  }, [])

  return <PaymentOrdersTemplate />
}

export default PaymentOrders
